import { SelectOption } from 'src/components/general/inputs/select/select';

export const entityToSelectOptionMapper = <T extends string | number>(entity: {
  id: T;
  name: string;
}): SelectOption<T> => ({
  value: entity.id,
  label: entity.name,
});
